import { useLexicalComposerContext } from "@lexical/react/LexicalComposerContext";
import { $getNearestNodeFromDOMNode, $getRoot, $isTextNode, LexicalNode, TextNode } from "lexical";
import { useEffect, FC } from "react";
import { $isColoredNode } from "../nodes/TableNode";
import { $getPageRoot, $isLayoutContainerNode } from "../nodes/LayoutContainerNode";


interface TableCaptionConfigProps {
    styleConfig: any;
    initialEditorState: any;
    showPagination: boolean
}

export const TableCaptionConfig: FC<TableCaptionConfigProps> = ({ styleConfig, initialEditorState, showPagination }) => {
    const [editor] = useLexicalComposerContext();

    useEffect(() => {
        if(styleConfig.heading) {
            editor.update(() =>{
                const styles = styleConfig.heading.find((h: any) => h.title === 'Captions')
                if(styles){
                  const editorState = showPagination ? $getPageRoot() : $getRoot();
                  if(!editorState) return;
                  ($isLayoutContainerNode(editorState) ? editorState.getAllChildren() : editorState.getChildren()).forEach((node)=>{
                    if($isColoredNode(node)){
                        if(styles.bold === "Yes"){
                            node.setStyle('color: bold ')
                        }else{
                            node.setStyle('font-weight: normal')
                        }
                        if(styles.italic === "Yes"){
                            node.setStyle('color: italic ')
                        }else{
                            node.setStyle('font-style: normal')
                        }
                        if(styles.fontColor){
                            node.setStyle(`color: ${styles.fontColor}`)
                        }
                        if(styles.fontSize){
                            node.setStyle(`font-size: ${styles.fontSize}px`)
                        }
                        if(styles.fontFamily){
                            node.setStyle(`font-family: ${styles.fontFamily}`)
                        }
                        if(styles.leadingSpace){
                            node.setStyle(`padding-top: ${styles.leadingSpace}em`)
                        }
                        if(styles.trailingSpace){
                            node.setStyle(`padding-bottom: ${styles.trailingSpace}em`)
                        }
                    }
                  })
                }
            })
        }
    }, [styleConfig, editor])

    return null;
}